import { decorateProperty as o } from "./base.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

var n;
var e = null != (null === (n = window.HTMLSlotElement) || void 0 === n ? void 0 : n.prototype.assignedElements) ? function (o, n) {
  return o.assignedElements(n);
} : function (o, n) {
  return o.assignedNodes(n).filter(function (o) {
    return o.nodeType === Node.ELEMENT_NODE;
  });
};

function l(n) {
  var _ref = null != n ? n : {},
      l = _ref.slot,
      t = _ref.selector;

  return o({
    descriptor: function descriptor(o) {
      return {
        get: function get() {
          var o;
          var r = "slot" + (l ? "[name=".concat(l, "]") : ":not([name])"),
              i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r),
              s = null != i ? e(i, n) : [];
          return t ? s.filter(function (o) {
            return o.matches(t);
          }) : s;
        },
        enumerable: !0,
        configurable: !0
      };
    }
  });
}

export { l as queryAssignedElements };